// A1 VAD 门控 (openspec/meeting-capture.md §19, meetily R1 — energy-gate
// variant). The current capture architecture uploads ONE whole take at stop and
// runs a periodic live-preview transcribe (PH-6b), so the cloud-ASR savings
// live at two gates: skip a preview window with no speech, and skip the final
// upload when the whole take stayed silent. Levels come from the existing mic
// meter (rms*4, 0..1); 0.02 is the meter's "silent" warn line, speech sits
// comfortably above it. Full Silero-style segment VAD (positive 0.50 / negative
// 0.35 / min-speech 250ms / redemption 2000ms) becomes relevant when a
// streaming/per-chunk or daemon capture path exists (B1) — parameters recorded
// in the spec, deliberately not shipped as a heavy dep today.

/** Meter level (0..1) at or above which a window counts as containing speech. */
export const VAD_SPEECH_LEVEL = 0.04;

/** Did a window whose PEAK meter level is `peak` contain speech? */
export function hasSpeech(peak: number, threshold = VAD_SPEECH_LEVEL): boolean {
  return peak >= threshold;
}

/**
 * Should this audio be sent to cloud ASR? Fail-OPEN: when the meter never ran
 * (`meterOk === false`, e.g. AudioContext unavailable) we must not guess
 * "silence" and drop the user's audio — no meter, no gating.
 */
export function shouldTranscribe(vadEnabled: boolean, meterOk: boolean, peak: number): boolean {
  if (!vadEnabled || !meterOk) return true;
  return hasSpeech(peak);
}
